module.exports = __webpack_public_path__ + "static/media/engage-design2.a49fb376.png";